import { Menu, MenuItem, Divider, ListItemIcon } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Logout from '@mui/icons-material/Logout';
import { CONFIG } from "../../Config";




const AnchorMenu = ({ anchorEl, open, handleClose, setShow194N, setViewNetwork, setViewElectionLetter, logOut, profileData }) => {

    const navigate = useNavigate();

    return <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
        {CONFIG.ANCHOR_MENU.map((menu) => {
            return (menu.title === "Download Partner Agreement" && profileData.role_name === "retailer") ? null : <MenuItem key={menu.id} onClick={() => {
                let params = menu.title === "View 194N" ? setShow194N : menu.title === "View Network Certificate" ?
                    setViewNetwork : menu.title === "IM Election Letter" ? setViewElectionLetter : navigate;
                menu.onClick(params)
            }}>
                {menu.title}
            </MenuItem>
        })}
        <Divider />
        <MenuItem onClick={logOut}>
            <ListItemIcon>
                <Logout variant="btnIconReport" fontSize="small" />
            </ListItemIcon>
            Logout
    </MenuItem>
    </Menu>
}

export default AnchorMenu
